// extracted by mini-css-extract-plugin
module.exports = {"baggageCard__title":"baggageCard__title-3tHne","baggageCard__description":"baggageCard__description-1BJZ2"};